import { Form, Input } from "antd";
import React from "react";

const PasswordConfirmForm = ({
  formStyle,
  label,
  prefix,
  placeholder,
  tip,
  required,
}: {
  formStyle?: string;
  label?: Boolean;
  prefix?: JSX.Element;
  placeholder?: Boolean;
  tip?: string;
  required?: Boolean;
}) => {
  return (
    <div className={formStyle}>
      <Form.Item
        name="password"
        label={label && "Password"}
        rules={[
          { required: required && true },
          {
            min: 8,
            message: "Password must contain at least 8 characters",
          },
          // FIXME can't be entirely numeric
          // /^-?\d+\.?\d*$/.test("")

          // {
          //   pattern: /^-?\d+\.?\d*$/,
          //   message: "Password can't be entirely numeric",
          // },
          // () => ({
          //   validator(_, value) {
          //     console.log("Pass length: _________", value.length);
          //     if (value.length < 8) Promise.resolve("");
          //     if (!/^-?\d+\.?\d*$/.test(value)) {
          //       return Promise.resolve();
          //     }
          //     return Promise.reject(
          //       new Error("Password can't be entirely numeric", value.length),
          //     );
          //   },
          // }),
        ]}
        hasFeedback
      >
        <Input.Password
          prefix={prefix}
          placeholder={placeholder && "New password"}
        />
      </Form.Item>
      {tip && (
        <div className="-mt-2.5 mb-4 text-[13px] text-black text-opacity-30">
          <span className="font-bold">Tip: </span>
          <span>{tip}</span>
        </div>
      )}
      <Form.Item
        name="confirmPassword"
        label={label && "Confirm Password"}
        dependencies={["password"]}
        hasFeedback
        rules={[
          {
            required: required && true,
            message: "Please confirm your password",
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!required && getFieldValue("password") && !value) {
                return Promise.reject(
                  new Error("Please confirm your password"),
                );
              }
              if (!value || getFieldValue("password") === value) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("The two passwords that you entered do not match"),
              );
            },
          }),
        ]}
      >
        <Input.Password
          prefix={prefix}
          placeholder={placeholder && "Confirm password"}
        />
      </Form.Item>
    </div>
  );
};

export default PasswordConfirmForm;
